"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var AddressResult = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #e5ebf0;\n  border-radius: 3px;\n  padding: 1em;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #e5ebf0;\n  font-size: 15px;\n"], ["\n  background-color: #e5ebf0;\n  border-radius: 3px;\n  padding: 1em;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #e5ebf0;\n  font-size: 15px;\n"])));
exports.default = AddressResult;
var templateObject_1;
